export enum SiteLocale {
    en = "en",
    sv = "sv",
}
